import { Component, ViewChild, ElementRef } from '@angular/core';
import { UploadImgService } from './upload-img.service';

@Component({
  selector: 'app-upload-img',
  templateUrl: './upload-img.component.html',
  styleUrls: ['./upload-img.component.scss']
})
export class UploadImgComponent {
  @ViewChild('imageInputElement') imageInputElement: ElementRef;

  imagePreview: string | ArrayBuffer | null = null;
  showPlaceholder = true;
  image: File = null;

  constructor(private uploadImageService: UploadImgService) { }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input && input.files && input.files.length) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const { result } = e.target as FileReader;
        this.imagePreview = result;
        this.showPlaceholder = false;
      };

      reader.readAsDataURL(file);
      this.image = file;
    }
  }

  sendImage(): void {
    this.uploadImageService.sendImage(this.image);
  }

  resetSelection(): void {
    this.imagePreview = null;
    this.showPlaceholder = true;
    this.image = null;

    if (this.imageInputElement) {
      this.imageInputElement.nativeElement.value = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/upload-img/upload-img.component.ts